import React, { useContext, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { grey } from '@material-ui/core/colors';
import { PageContext } from '../context';
import { StyledButton } from '../../../components/Forms/styles';
import { FooterWrapper, FooterText, FooterTextWrapper } from '../styles';
import AlertMessage from '../../../components/AlertMessage';
import Loading from '../../../components/Loading';

const BrandFooter = ({ title, disabled, handleClick }) => {
  const [isLoading, setLoading] = useState(false);
  const context = useContext(PageContext);
  const { goToNextStep } = context;
  const [alertData, setAlertData] = useState({
    open: false,
    handleClose: () => false,
    variant: 'error',
    message: '',
    duration: 3000,
  });

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setAlertData({ open: false });
  };

  const showError = (error) => {
    const newData = {
      ...alertData,
      open: true,
      message: error,
      handleClose,
    };
    setAlertData(newData);
  };

  const onSubmit = useCallback(() => {
    setLoading(true);
    Promise.resolve(handleClick())
      .then(
        () => goToNextStep(),
        (e) => showError(e),
      )
      .finally(() => {
        setLoading(false);
      });
  }, [goToNextStep, handleClick]);

  return (
    <>
      <FooterWrapper>
        <StyledButton
          bgcolor="var(--brand-color)"
          disabled={disabled}
          onClick={onSubmit}
          textcolor={grey[200]}
        >
          <FooterTextWrapper>
            {isLoading && <Loading small color="white" />}
            {!isLoading && <FooterText>{title}</FooterText>}
          </FooterTextWrapper>
          <ArrowForwardIcon />
        </StyledButton>
      </FooterWrapper>
      <AlertMessage {...alertData} />
    </>
  );
};

BrandFooter.defaultProps = {
  disabled: false,
  title: 'Next',
  handleClick: () => {},
};

BrandFooter.propTypes = {
  disabled: PropTypes.bool,
  title: PropTypes.string,
  handleClick: PropTypes.func,
};

export default BrandFooter;
